import Footer from '@/organisms/Footer';
import NavBar from '@/organisms/NavBar';
import { LayoutProps } from '../types';

const ClassicLayout = ({ children, acf: { header, footer }, template }: LayoutProps) => (
  <div className="flex flex-col min-h-screen bg-nublu-50" data-attr-template-name={template} id="top">
    {header !== 'hidden' && <NavBar />}
    <main className="min-h-lvh grow mt-header-mobile lg:mt-header pb-footer max-w-1200 m-auto w-full pt-2 lg:pt-6 px-2 lg:px-4">
      {children}
    </main>
    {footer !== 'hidden' && <Footer />}
  </div>
);

export default ClassicLayout;
